import { classNames } from "@/shared/utils/classnames";

import React, { FC, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoneyCheckDollar } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { DateTime } from "luxon";
import i18n from "@/app/i18n";

export type PaymentIntentCardProps = {
  paymentIntent: any;
};

export const PaymentIntentCard: FC<PaymentIntentCardProps> = ({
  paymentIntent,
}) => {
  const [t] = useTranslation();

  return (
    <li className={classNames("col-span-1 flex rounded-md shadow-sm ")}>
      <div className="bg-primary flex w-16 flex-shrink-0 items-center justify-center rounded-l-md text-sm font-medium text-white">
        <Fragment>
          <FontAwesomeIcon icon={faMoneyCheckDollar} className="text-2xl" />
        </Fragment>
      </div>
      <div className="flex flex-1 items-center justify-between truncate rounded-r-md border-b border-r border-t border-gray-200 bg-white">
        <div className="flex-1 truncate px-4 py-2 text-sm">
          <a className="font-medium text-gray-900 hover:text-gray-600">
            {`${paymentIntent.currency.toUpperCase()} ${(paymentIntent.amount / 100).toFixed(2)}`}
          </a>
          <div className="flex gap-4">
            <p className="text-gray-500">
              {DateTime.fromISO(paymentIntent.createdAt)
                .setLocale(i18n.language)
                .toFormat("d MMMM yyyy")}
            </p>
          </div>
        </div>
      </div>
    </li>
  );
};
